import React from "react";
import { motion } from "framer-motion";
import { Clock, ShieldCheck, SearchCheck, Hammer } from "lucide-react";
import { TRUST } from "../../data/content";

const ICONS = [Clock, ShieldCheck, SearchCheck, Hammer];

export const TrustBanner = () => {
  return (
    <section data-testid="trust-banner" className="max-w-[1400px] mx-auto px-5 md:px-12 py-16 md:py-24">
      <div className="grid grid-cols-2 lg:grid-cols-4 gap-x-6 gap-y-10">
        {TRUST.map((item, i) => {
          const Icon = ICONS[i];
          return (
            <motion.div
              key={i}
              initial={{ opacity: 0, y: 24 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: "-60px" }}
              transition={{ duration: 0.6, delay: i * 0.08 }}
              className="pt-6 border-t-2 border-[#0A1F10]/10"
              data-testid={`trust-item-${i}`}
            >
              <Icon className="w-7 h-7 text-[#5AB82D] mb-4" strokeWidth={1.5} />
              <h3 className="font-serif-display text-2xl font-semibold text-[#0A1F10] leading-tight">
                {item.title}
              </h3>
              <p className="mt-2 text-sm text-[#4B5E51] leading-relaxed">{item.text}</p>
            </motion.div>
          );
        })}
      </div>
    </section>
  );
};
